import { Component, OnInit } from '@angular/core';
import { CleverTapConstents } from 'src/app/services/constants';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-key-fact-statement',
  templateUrl: './key-fact-statement.component.html',
  styleUrls: ['./key-fact-statement.component.scss']
})
export class KeyFactStatementComponent implements OnInit {
  isChecked: boolean = false;
  iframeSrc: any;
  totalPages:any;

  constructor(public util: UtilService,) { }
  ngOnInit(): void {
    this.showDocument();
    
  }

  showDocument() {
    this.util.handleRequests('blobFile', this.util.getUrl('kfs_download', [this.util.loanDetails.loanId]))
      .then((res: any) => {
        this.iframeSrc = res.blobFile;
      });
  }

  confirmKfs() {
    this.util.handleRequests('put', this.util.getUrl('kfs_confirm'), { "loanId": this.util.loanDetails.loanId }).then(res => {
      if (res.status == 'SUCCESS') {
        // route to next screen
        this.util.handleRequests('put', this.util.getUrl('loan_confirm_applicationForm'), { "loanId": this.util.loanDetails.loanId }).then((res) => {
          if (res.status == 'SUCCESS') {
            this.util.cleverTapEventCall(CleverTapConstents.accept_KFS,{
              'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
            });
            this.util.getProducts().then(() => {
              this.util.navigationHandler();
            });
          }
        });

      }

    });
  }

  onLoadComplete(event: any) {
    this.totalPages = event.numPages;
  }

  calculateHeight(){
    const pageHeight = this.util.isMobile ? 900: 1466;
    const height =  document.querySelector('.page') ? +(<any>document.querySelectorAll('.page')[0]).style.height.split('px')[0] : pageHeight;

    return `calc(${height + 20}px * ${this.totalPages})`;
  }

}
